import React from 'react';
import styles from './DrawerLayout.less';
import Drawer from '@/components/Drawer';

export interface DrawerLayoutProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
  width?: number | string;
  isDirty?: boolean;
}

const DrawerLayout: React.FC<DrawerLayoutProps> = ({
  open,
  title,
  onClose,
  children,
  width = 720,
  isDirty = false,
}) => {
  const handleClose = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  return (
    <Drawer
      open={open}
      width={width}
      placement="right"
      closable={false}
      title={title}
      onOpenChange={handleClose}
      className={styles.drawerRoot}
      destroyOnHidden
    >
        {children}
    </Drawer>
  );
};

export default DrawerLayout;
